import * as React from "react";

function SvgComment(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 21.804L12.087 18H20a2 2 0 002-2V4a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h2v3.804zM11.513 16L8 18.196V16H4V4h16v12h-8.487z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgComment;
